import firebase from 'firebase'
//import firestore from 'firebase/firestore'


 // Initialize Firebase
 var config = {
    apiKey: "AIzaSyD4ee_lP2LuS2AmnMb8OaXgzRGkp-IzdNU",
    authDomain: "appricot-geo.firebaseapp.com",
    databaseURL: "https://appricot-geo.firebaseio.com",
    projectId: "appricot-geo",
    storageBucket: "appricot-geo.appspot.com",
    messagingSenderId: "181087066839"
  };
  const firebaseApp = firebase.initializeApp(config);
  firebaseApp.firestore().settings({timestampsInSnapshots: true}); 
 
  
  export default firebaseApp.firestore()



// WEBPACK FOOTER //
// ./src/firebase/init.js